import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const [darkTheme, setDarkTheme] = useState(false);

  // Check if we're on the homepage to apply dark theme
  useEffect(() => {
    setDarkTheme(location.pathname === '/');
  }, [location.pathname]);

  const footerLinks = {
    about: [
      { name: 'About Us', href: '/about' },
      { name: 'Contact', href: '/contact' },
      { name: 'Privacy Policy', href: '/privacy-policy' },
      { name: 'Terms of Service', href: '/terms-of-service' }
    ],
    services: [
      { name: 'Search Directory', href: '/search' },
      // { name: 'Find a Solicitor', href: '/search' },
      { name: 'Legal Services', href: '/legal-services' },
      { name: 'SRA Website', href: 'https://www.sra.org.uk/', external: true }
    ],
    contact: [
      { name: 'support@zahoot.ai', href: 'mailto:support@zahoot.ai' },
      { name: '01216 303115', href: 'tel:01216303115' }
    ]
  };

  return (
    <>
      <div className={`footer__cta-wrapper ${darkTheme ? 'dark-theme' : ''}`}>
        <div className="footer__cta">
          <div className="footer__cta-inner">
            <div className="footer__cta-container">
              <h2 className="footer__cta-title">Ready to find your legal expert?</h2>
              <p className="footer__cta-text">
                Search our comprehensive directory of UK solicitors and law firms
              </p>
              <Link to="/search" className="btn">
                Search Directory
              </Link>
            </div>
          </div>
        </div>
      </div>

      <footer className={`footer ${darkTheme ? 'dark-theme' : ''}`}>
        <div className="footer__container">
          <div className="footer__content">
            <div className="footer__brand">
              <Link to="/" className="footer__logo">
              <svg width="32" height="32" viewBox="0 0 49 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 45.0562V2.22206C0 0.994851 0.994852 0 2.22206 0H39.4518C41.3574 0 42.379 2.24145 41.1289 3.67974L3.89918 46.5139C2.55082 48.0652 0 47.1116 0 45.0562Z" fill="url(#paint0_linear_10_872)"/>
                <path d="M49 48.8236V24.343C49 22.3234 46.5238 21.3511 45.1496 22.831L22.419 47.3116C21.0988 48.7334 22.1071 51.0457 24.0473 51.0457H46.7779C48.0051 51.0457 49 50.0508 49 48.8236Z" fill="url(#paint1_linear_10_872)"/>
                <defs>
                  <linearGradient id="paint0_linear_10_872" x1="0.24833" y1="1.34331" x2="51.8042" y2="52.0243" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#FE5F70"/>
                  <stop offset="1" stop-color="#8B76E3"/>
                  </linearGradient>
                  <linearGradient id="paint1_linear_10_872" x1="0.24833" y1="1.34331" x2="51.8042" y2="52.0243" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#FE5F70"/>
                  <stop offset="1" stop-color="#8B76E3"/>
                  </linearGradient>
                </defs>
              </svg>

              <span>Zahoot</span>
              </Link>
              <p className={`footer__brand-text ${darkTheme ? 'text-gray-300' : ''}`}>
                The comprehensive directory of UK solicitors and law firms regulated by the Solicitors Regulation Authority.
              </p>
            </div>

            <div className="footer__links-section">
              <h3 className={`footer__links-title ${darkTheme ? 'text-white' : ''}`}>About</h3>
              <ul className="footer__links-list">
                {footerLinks.about.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className={`footer__link ${darkTheme ? 'footer__link--dark' : ''}`}>
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer__links-section">
              <h3 className={`footer__links-title ${darkTheme ? 'text-white' : ''}`}>Services</h3>
              <ul className="footer__links-list">
                {footerLinks.services.map((link) => (
                  <li key={link.name}>
                    {link.external ? (
                      <a href={link.href} target="_blank" rel="noopener noreferrer" className={`footer__link ${darkTheme ? 'footer__link--dark' : ''}`}>
                        {link.name}
                      </a>
                    ) : (
                      <Link to={link.href} className={`footer__link ${darkTheme ? 'footer__link--dark' : ''}`}>
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer__links-section">
              <h3 className={`footer__links-title ${darkTheme ? 'text-white' : ''}`}>Contact</h3>
              <ul className="footer__links-list">
                {footerLinks.contact.map((link) => (
                  <li key={link.name}>
                    <a href={link.href} className={`footer__link ${darkTheme ? 'footer__link--dark' : ''}`}>
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="footer__bottom">
            <p className={`footer__copyright ${darkTheme ? 'text-gray-400' : ''}`}>
              © {currentYear} Zahoot. All rights reserved.
            </p>
          </div>

          <div className="footer__legal text-center">
            <p className={`text-xs ${darkTheme ? 'text-gray-400' : 'text-gray-500'}`}>
              Zahoot maintains a comprehensive directory of all registered law practices in England and Wales, utilising official data provided by the <a href="https://www.sra.org.uk/" target="_blank" rel="nofollow noopener noreferrer" className={darkTheme ? 'text-gray-300 hover:text-white' : ''}>Solicitors Regulation Authority (SRA)</a>.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer; 